import React from "react";

const ChatWelcome = () => {
  return (
    <div className="chatWelcome">
      <img
        className="iiitd_img1"
        src="https://www.iiitd.ac.in/convocation22/img/IIITD.jpeg"
        alt="iiitd background"
      />
      <div className="centered">Select the Conversation to chat</div>
    </div>
  );
};

export default ChatWelcome;